module.exports = __webpack_public_path__ + "static/fun-time/games/page001_game1/audio//Track_11_Story_2_Colours.mp3";